module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de contratos de mi equipo")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudesPorAprobar) ? _c('div', {
    key: "lista_solicitud_por_aprobar",
    staticClass: "box position-relative"
  }, [_c('lista-solicitudes-por-aprobar', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudesPorAprobar = false
      }
    }
  })], 1) : _vm._e(), (_vm.mostrarListaEquipo) ? _c('div', {
    key: "lista_equipo",
    staticClass: "box position-relative"
  }, [_c('lista-equipo-contratos', {
    on: {
      "close": function($event) {
        _vm.mostrarListaEquipo = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06bfe8ec","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Contratos_Equipo.vue
// module id = 812
// module chunks = 0